import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface DrivewayAndWalksProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const DrivewayAndWalks: React.FC<DrivewayAndWalksProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [drivewayAndWalks, setDrivewayAndWalks] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Driveway/Sidewalk'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], 'Driveway/Sidewalk': v } } })
    );
    const label = 'Driveway/AndWalks';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={drivewayAndWalks}
                />
            ) : (
                <TextBox
                    value={drivewayAndWalks ?? ''}
                    onChange={(value) => setDrivewayAndWalks(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
